/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Error_Zalo_Oauth_Callback_InvalidInputs */

const vi_error_zalo_oauth_callback_invalid = /** @type {(inputs: Error_Zalo_Oauth_Callback_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trang Zalo chuyển về thiếu thông tin (${i?.field}). Bấm Kết nối lại.`)
};

/**

* @param {Error_Zalo_Oauth_Callback_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_oauth_callback_invalid = /** @type {((inputs: Error_Zalo_Oauth_Callback_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Oauth_Callback_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_oauth_callback_invalid(inputs)
});